import { useState } from 'react';
import './Header.css';

function Header({ player, onDashboard, onHome }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-logo">
          <img
            src="/logo.png"
            alt="Mammut-Partner"
            onClick={onHome}
            style={{ height: '70px', width: 'auto' }}
          />
        </div>

        <button
          className="header-burger"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Menü öffnen"
        >
          {menuOpen ? '✕' : '☰'}
        </button>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <a href="#" onClick={() => setMenuOpen(false)}>Dienstleistungen</a>
          <a href="#" onClick={() => setMenuOpen(false)}>Leistungen</a>
          <a href="#" onClick={() => setMenuOpen(false)}>Referenzen</a>
          <a href="#" onClick={() => setMenuOpen(false)}>Über uns</a>
          <a href="#" onClick={() => setMenuOpen(false)}>Karriere</a>
          {player && (
            <button className="btn-dashboard" onClick={() => { setMenuOpen(false); onDashboard(); }}>
              Dashboard
            </button>
          )}
          <button className="btn-beratung" onClick={() => setMenuOpen(false)}>
            Kostenlose Erstberatung
          </button>
        </nav>
      </div>
      {player && (
        <div className="header-player">
          <span>{player.name}</span>
          <span className="level-badge">{player.current_level}</span>
        </div>
      )}
    </header>
  );
}

export default Header;